import request from '@/utils/request';
/**获取列表数据 */
export function dataPanel(data) {
  return request.post('admin/dashboard/data-panel', data);
}
/**获取配置的数据看板类型 */
export function panelType() {
  return request.post('admin/dashboard/panel-type', {});
}